const notificationType = {
	super_admin_sign_up: "super_admin_sign_up",
	creation: "creation",
	registration: "registration",
	approval: "approval",
	member_chat_support: "member_chat_support",
	employer_chat_support: "employer_chat_support",
	statement_of_understanding: "statement_of_understanding",
	registration_help: "registration_help",
	blogs: "blogs",
	announcements: "announcements",
	edit: "edit",
	plan_creation: "plan_creation",
	open_enrollment: "open_enrollment",
	enrollment_submission: "enrollment_submission",
	terminate: "terminate",
	reinstate: "reinstate",
	rehire: "rehire",
	enroller_action: "enroller_action"
};

export const NOTIFICATION_TYPE = notificationType;
